
define('text!meetings/action-center/action-center.html',[],function () { return '<div\n    class="container g2mm-action-center-container"\n>\n  <div\n    data-bind="react: reactOptions"\n    class="col-sm-10 col-sm-offset-1"\n  />\n</div>';});

